import React, { useState, useEffect, useRef } from "react";
import styles from "../../assets/css/forms.module.css";
import commonCss from "../../assets/css/common.module.css";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { postData1 } from "../../../services";
import { ToastContainer, toast } from "react-toastify";
import prevIcon from "../../../assets/images/previous_arrow.png";
import nextIcon from "../../../assets/images/next_arrow.png";
import { orderStatus } from "../../MappedData";
import axios from "axios";
import { Loader } from "../../../components/Loader";

export const OrderForm = () => {
  const [isDisable, setisDisable] = useState(true);
  const [perm, updatePerm] = useState(true);
  const location = useLocation();
  const userData = location.state;
  const [imgs, setImgs] = useState(userData?.product_detail?.product_images);
  const [imgPointer, setImgPointer] = useState(0);
  const [videoPointer, setVideoPointer] = useState(0);
  const [videos, setVideos] = useState(userData?.product_detail?.product_video);
  const [currStatus, setStatus] = useState(userData?.order_status);
  const [isOpen, setOpen] = useState(false);
  const [paymentHistoryData, setPaymentHistoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [paymentsOthers, setPayementOthers] = useState("")

  // console.log(userData)
  // Store original paid amount (from the order) in a ref
  const originalPaidRef = useRef(parseFloat(userData?.others?.amount_paid) || 0);

  const deliveryAddress = userData?.delivery_address;
  const fullAddressText = deliveryAddress
    ? `
      Name: ${deliveryAddress.name}
      Mobile: ${deliveryAddress.mobile}
      Address: ${deliveryAddress.address}
      Location: ${deliveryAddress.location}
      Landmark: ${deliveryAddress.landmark}
      City: ${deliveryAddress.city}
      State: ${deliveryAddress.state}
      Pincode: ${deliveryAddress.zip_code}
      `
    : "";

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      orderid: userData?.id || "",
      prodId: userData?.product_detail?.id || "",
      delivryAdd: fullAddressText,
      postType: userData?.product_detail?.post_type || "",
      equipName: userData?.product_detail?.equip_name || "",
      buyerFname: userData?.buyer_firstname || "",
      buyerLname: userData?.buyer_lastname || "",
      buyer_phone: userData?.buyer_phone || "",
      sellerFname: userData?.seller_firstname || "",
      sellerLname: userData?.seller_lastname || "",
      discount: userData?.discount || "",
      remain: userData?.remain_amount || "",
      subTotal: userData?.sub_total || "",
      tax: userData?.tax || "",
      total: userData?.total || "",
      orderStatus: userData?.order_status || "",
      payStatus: userData?.payment_status || "",
      payType: userData?.payment_type || "",
      amount_paid: 0, // additional payment, starts at 0
    },
  });

  // Auto‑recalculate total from subTotal, discount, tax
  useEffect(() => {
    const sub = parseFloat(formik.values.subTotal) || 0;
    const disc = parseFloat(formik.values.discount) || 0;
    const tax = parseFloat(formik.values.tax) || 0;
    const newTotal = sub - disc + tax;
    formik.setFieldValue("total", newTotal);
  }, [formik.values.subTotal, formik.values.discount, formik.values.tax]);

  // Auto‑update remain based on total and cumulative paid
  useEffect(() => {
    const totalVal = parseFloat(formik.values.total) || 0;
    const additional = parseFloat(formik.values.amount_paid) || 0;
    const cumulativePaid = originalPaidRef.current + additional;
    let remain = totalVal - cumulativePaid;
    if (remain < 0) remain = 0;
    formik.setFieldValue("remain", remain);
  }, [formik.values.total, formik.values.amount_paid]);

  // Auto‑update payment status based on remain vs total
  useEffect(() => {
    const remain = parseFloat(formik.values.remain) || 0;
    const total = parseFloat(formik.values.total) || 0;
    let status = 1; // Pending
    if (remain === 0) status = 3; // Completed
    else if (remain < total && remain > 0) status = 2; // Partial
    formik.setFieldValue("payStatus", status);
  }, [formik.values.remain, formik.values.total]);

  const handleOrderStatus = (e, data) => {
    setStatus(data);
    setOpen(false);
  };

  const moveImg = (e, isVideo) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      isVideo
        ? setVideoPointer(videoPointer === 0 ? 0 : videoPointer - 1)
        : setImgPointer(imgPointer === 0 ? 0 : imgPointer - 1);
    } else {
      isVideo
        ? setVideoPointer(
            videoPointer === videos?.length - 1
              ? videos?.length - 1
              : videoPointer + 1
          )
        : setImgPointer(
            imgPointer === imgs?.length - 1 ? imgs?.length - 1 : imgPointer + 1
          );
    }
  };

  const updateOrderStatus = async () => {
    setIsLoading(true);
    const deliveryAddress = userData?.delivery_address;
    const address =
      deliveryAddress.address +
      " " +
      deliveryAddress.location +
      " " +
      deliveryAddress.city +
      " " +
      deliveryAddress.zip_code +
      " " +
      deliveryAddress.state;
      
    const res = await postData1(
      "admin/update_order_status/",
      {
        uid: userData?.uid,
        order_status: currStatus,
        product_name: userData?.product_detail?.equip_name,
        buyer_name: userData?.buyer_firstname,
        buyer_email: userData?.buyer_email,
        amount: userData?.total || "",
        address: address,
      },
      true,
      true
    );
    if (res?.status_code === 200) {
      toast.success("Status updated successfully!");
    } else {
      toast.error("Something went wrong, try again!");
    }
    setIsLoading(false);
  };

      const handlePaymentOthersChange = (e) => {
          const { name, value } = e.target;

          setPayementOthers(e.target.value);
        };

  const createPaymentRecord = async (paymentStatus, paidAmount, token) => {
    try {
      const paymentPayload = {
        order: userData?.uid,
        order_type: 1,
        product: userData?.product_detail?.uid,
        sub_total: parseFloat(formik.values.subTotal) || 0,
        total: paidAmount,
        payment_mode: userData?.others?.payment_mode || "offline",
        payment_status: paymentStatus,
        buyer: userData?.buyer,
        others:paymentsOthers
      };

      const paymentRes = await axios.post(
        `${process.env.REACT_APP_BASEURL}/product/order/payment/`,
        paymentPayload,
        {
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (paymentRes.status === 201) {
        toast.success("Payment record created successfully!");
        paymentHistory(); // refresh history after new payment
      } else {
        console.warn("Payment record creation failed:", paymentRes);
      }
    } catch (error) {
      console.error("Payment creation error:", error);
    }
  };

  const handleAmountPaidChange = (e) => {
    const value = e.target.value;
    const total = parseFloat(formik.values.total) || 0;
    const remainingAmount = Math.max(total - originalPaidRef.current, 0);

    if (value === "") {
      formik.setFieldValue("amount_paid", "");
      return;
    }

    const amount = parseFloat(value);
    if (Number.isNaN(amount)) return;

    if (amount > remainingAmount) {
      formik.setFieldValue("amount_paid", remainingAmount);
      toast.warning(`Amount cannot be more than the remaining balance of ${formatCurrency(remainingAmount)}`);
      return;
    }

    formik.setFieldValue("amount_paid", amount);
  };



  const updateAmount = async () => {
    const additional = parseFloat(formik.values.amount_paid) || 0;
    const totalVal = parseFloat(formik.values.total) || 0;
    const remainingAmount = Math.max(totalVal - originalPaidRef.current, 0);
    if (additional <= 0) {
      toast.warning("Please enter an amount greater than 0");
      return;
    }
    if (additional > remainingAmount) {
      toast.warning(`Amount cannot be more than the remaining balance of ${formatCurrency(remainingAmount)}`);
      return;
    }
    const cumulativePaid = originalPaidRef.current + additional;
    let remain = totalVal - cumulativePaid;
    if (remain < 0) remain = 0;

    let paymentStatus = 1;
    if (remain === 0) paymentStatus = 3;
    else if (remain < totalVal && remain > 0) paymentStatus = 2;

    const token = localStorage.getItem("adminAuth");

    try {
      const orderPayload = {
        sub_total: parseFloat(formik.values.subTotal) || 0,
        discount: parseFloat(formik.values.discount) || 0,
        tax: parseFloat(formik.values.tax) || 0,
        total: totalVal,
        remain_amount: remain,
        payment_status: paymentStatus,
        others: {
          amount_paid: cumulativePaid,
          payment_mode: userData?.others?.payment_mode || "offline",
        },
      };

      const orderRes = await axios.patch(
        `${process.env.REACT_APP_BASEURL}/product/order/${userData?.id}/`,
        orderPayload,
        {
          headers: {
            accept: "application/json",
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (orderRes.status === 200) {
        toast.success("Amount updated successfully!");
        await createPaymentRecord(paymentStatus, additional, token);
        // Update the reference and reset the additional field
        originalPaidRef.current = cumulativePaid;
        formik.setFieldValue("amount_paid", 0);
        // Optionally refresh the order data to reflect new values
        // You could refetch order details here if needed
      } else {
        toast.error("Failed to update order amount.");
      }
    } catch (error) {
      console.error("Update amount error:", error);
      toast.error("Something went wrong, try again!");
    }
  };


  const paymentHistory = async () => {
    const payload = {
      order_uid: userData?.uid,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/payment_details_of_order/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${localStorage.getItem("adminAuth")}`,
          },
        }
      );
      setPaymentHistoryData(response?.data?.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    paymentHistory();
  }, []);

  // Helper to format currency
  const formatCurrency = (value) => {
    return parseFloat(value || 0).toFixed(2);
  };


 
  return (
    <section className={styles.formCont}>
      {isLoading && <Loader/>}
      <ToastContainer />

      <div className={styles.updateForm}>
        {/* Main order details - all read-only */}
        <div className={styles.formFieds}>
          <div>
            <p>Order Id</p>
            <input disabled type="text" value={formik.values.orderid} />
          </div>
          <div>
            <p>Product Id</p>
            <input disabled type="text" value={formik.values.prodId} />
          </div>
          <div>
            <p>Product</p>
            <input disabled type="text" value={formik.values.equipName} />
          </div>
          <div>
            <p>Product Type</p>
            <input
              disabled
              type="text"
              value={
                formik.values.postType === 1
                  ? "PREOWNED"
                  : formik.values.postType === 2
                  ? "NEW"
                  : formik.values.postType === 3
                  ? "SPARE & ACCESSORIES"
                  : "SERVICES"
              }
            />
          </div>
          <div>
            <p>Buyer First Name</p>
            <input disabled type="text" value={formik.values.buyerFname} />
          </div>
          <div>
            <p>Buyer Last Name</p>
            <input disabled type="text" value={formik.values.buyerLname} />
          </div>
          <div>
            <p>Buyer Mobile No.</p>
            <input disabled type="text" value={formik.values.buyer_phone} />
          </div>
          <div>
            <p>Seller First Name</p>
            <input disabled type="text" value={formik.values.sellerFname} />
          </div>
          <div>
            <p>Seller Last Name</p>
            <input disabled type="text" value={formik.values.sellerLname} />
          </div>

          {/* Order totals - read-only */}
          <div>
            <p>Sub Total</p>
            <input disabled type="text" value={formik.values.subTotal} />
          </div>
          <div>
            <p>Discount</p>
            <input disabled type="text" value={formik.values.discount} />
          </div>
          <div>
            <p>Tax</p>
            <input disabled type="text" value={formik.values.tax} />
          </div>
          <div>
            <p>Total</p>
            <input disabled type="text" value={formik.values.total} />
          </div>
          <div>
            <p>Remains</p>
            <input disabled type="text" value={formik.values.remain} />
          </div>

          {/* Order status & payment status - read-only */}
          <div>
            <p>Order Status</p>
            <input
              disabled
              type="text"
              value={orderStatus[formik.values.orderStatus]}
            />
          </div>
          <div>
            <p>Payment Status</p>
            <input
              disabled
              type="text"
              value={
                formik.values.payStatus === 1
                  ? "Pending"
                  : formik.values.payStatus === 2
                  ? "Partial"
                  : "Completed"
              }
            />
          </div>
          <div>
            <p>Payment Type</p>
            <input
              disabled
              type="text"
              value={formik.values.payType === 1 ? "Active" : "InActive"}
            />
          </div>

          <div>
            <p>Delivery Address</p>
            <textarea
              disabled
              rows={10}
              className="w-full border rounded p-2"
              value={formik.values.delivryAdd}
            />
          </div>

          {/* Images and videos */}
          <div>
            <p>Images</p>
            <div
              style={{
                backgroundImage: `url(${imgs?.[imgPointer]?.product_images})`,
              }}
              className={styles.imgeCont}
            ></div>
            <div className={styles.vidMover}>
              <img
                src={prevIcon}
                onClick={(e) => moveImg(e, 0)}
                alt="Prev"
                name="prev"
              />
              <p style={{ textAlign: "center" }}>
                {imgs?.length === 0 ? 0 : imgPointer + 1}/{imgs?.length}
              </p>
              <img
                src={nextIcon}
                onClick={(e) => moveImg(e, 0)}
                alt="Next"
                name="next"
              />
            </div>
          </div>

          <div>
            <p>Videos</p>
            <video className={styles.imgeCont} controls>
              <source src={videos?.[videoPointer]} type="video/mp4" />
            </video>
            <div className={styles.vidMover}>
              <img
                src={prevIcon}
                onClick={(e) => moveImg(e, 1)}
                alt="Prev"
                name="prev"
              />
              <p style={{ textAlign: "center" }}>
                {videos?.length === 0 ? 0 : videoPointer + 1}/{videos?.length}
              </p>
              <img
                src={nextIcon}
                onClick={(e) => moveImg(e, 1)}
                alt="Next"
                name="next"
              />
            </div>
          </div>
        </div>

  <div className="flex flex-col lg:flex-row items-start justify-between gap-8 w-full p-4">
  
  {/* ========== AMOUNT UPDATE SECTION ========== */}
  {userData?.others?.payment_mode ==="offline" &&
  (
      <div className="w-full lg:w-1/2 bg-white shadow-sm border border-gray-200 rounded-xl p-6">
    <h3 className="text-lg font-semibold text-gray-800 border-b border-gray-100 pb-4 mb-5">
      Amount Management
    </h3>
    
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {/* Total Order Value */}
      <div className="bg-gray-50 rounded-lg p-4 flex flex-col justify-center">
        <label className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
          Total Order Value
        </label>
        <span className="text-lg font-semibold text-gray-900">
          ₹ {formatCurrency(formik.values.total)}
        </span>
      </div>

      {/* Already Paid */}
      <div className="bg-gray-50 rounded-lg p-4 flex flex-col justify-center">
        <label className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
          Already Paid
        </label>
        <span className="text-lg font-semibold text-gray-900">
          ₹ {formatCurrency(originalPaidRef.current)}
        </span>
      </div>

      {/* Remaining (before new payment) */}
      <div className="bg-gray-50 rounded-lg p-4 flex flex-col justify-center">
        <label className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
          Remaining Balance
        </label>
        <span className="text-lg font-semibold text-gray-900">
          ₹ {formatCurrency(userData?.remain_amount || 0)}
        </span>
      </div>

      {/* Additional Payment Input */}
      <div className="bg-blue-50/50 border border-blue-100 rounded-lg p-4 flex flex-col justify-center">
        <label className="text-xs font-medium text-blue-700 uppercase tracking-wider mb-2">
          Additional Payment
        </label>
        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500 font-medium">₹</span>
          <input
            type="number"
            name="amount_paid"
            value={formik.values.amount_paid}
            onChange={handleAmountPaidChange}
            onBlur={formik.handleBlur}
            className="w-full pl-8 pr-3 py-2 bg-white border border-gray-300 rounded-md text-sm shadow-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors"
            min="0"
            max={Math.max((parseFloat(formik.values.total) || 0) - originalPaidRef.current, 0)}
            step="0.01"
            placeholder="0.00"
          />
        </div>
      </div>

      {/* Notes */}
      <div className="sm:col-span-2  border border-blue-100 rounded-lg p-4 flex flex-col items-start justify-between mt-2">
        <label className="text-sm font-semibold text-blue-800">
          Notes
        </label>
     <input
            type="text"
            name="payment_others"
            value={paymentsOthers}
            onChange={handlePaymentOthersChange}
  
            className="w-full pl-8 pr-3 py-2 bg-white border border-gray-300 rounded-md text-sm shadow-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors"
         
          />
      </div>
      {/* New Remaining */}
      <div className="sm:col-span-2 bg-red-50 border border-red-100 rounded-lg p-4 flex items-center justify-between mt-2">
        <label className="text-sm font-semibold text-red-800">
          New Remaining (after payment)
        </label>
        <span className="text-xl font-bold text-red-600">
          ₹ {formatCurrency(formik.values.remain)}
        </span>
      </div>
    </div>

    {/* <button 
      // disabled={userData?.remain_amount === 0}
      disabled={Number(userData?.remain_amount) === 0}
      onClick={updateAmount}
      className={`mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
    >
      Save Payment
    </button> */}
    <button
  disabled={Number(userData?.remain_amount) === 0}
  onClick={updateAmount}
  className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-gray-400 disabled:hover:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-70"
>
  Save Payment
</button>
  </div>
  )}


  {/* ========== PAYMENT HISTORY ========== */}
  <div className="w-full lg:w-1/2 bg-white shadow-sm border border-gray-200 rounded-xl p-6">
    <h3 className="text-lg font-semibold text-gray-800 border-b border-gray-100 pb-4 mb-5">
      Payment History
    </h3>
    
    {paymentHistoryData.length === 0 ? (
      <div className="flex flex-col items-center justify-center py-10 text-gray-400">
        <svg className="w-12 h-12 mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <p className="text-sm">No payments recorded yet.</p>
      </div>
    ) : (
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left text-gray-600">
          <thead className="text-xs text-gray-500 uppercase bg-gray-50/80 rounded-t-lg">
            <tr>
              <th className="px-4 py-3 font-medium rounded-tl-lg">Date</th>
              <th className="px-4 py-3 font-medium">Amount</th>
              {/* <th className="px-4 py-3 font-medium">Mode</th> */}
              <th className="px-4 py-3 font-medium rounded-tr-lg">Status</th>
              <th className="px-4 py-3 font-medium rounded-tr-lg">Notes</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {paymentHistoryData.map((payment) => (
              // console.log(payment) ,
              <tr key={payment.uid} className="hover:bg-gray-50/50 transition-colors">
                <td className="px-4 py-3 whitespace-nowrap">
                  {new Date(payment.created_date).toLocaleDateString(undefined, { 
                    year: 'numeric', month: 'short', day: 'numeric' 
                  })}
                  <span className="text-gray-400 text-xs block mt-0.5">
                    {new Date(payment.created_date).toLocaleTimeString(undefined, {
                      hour: '2-digit', minute: '2-digit'
                    })}
                  </span>
                </td>
                <td className="px-4 py-3 font-medium text-gray-900">
                  ₹ {formatCurrency(payment.total)}
                </td>
                {/* <td className="px-4 py-3 capitalize">
                  {payment.payment_mode || "Offline"}
                </td> */}
                <td className="px-4 py-3">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                    ${payment.payment_status === 3 
                      ? "bg-green-100 text-green-800" 
                      : payment.payment_status === 2 
                      ? "bg-yellow-100 text-yellow-800" 
                      : "bg-gray-100 text-gray-800"
                    }`}
                  >
                    {payment.payment_status === 3 ? "Completed" 
                     : payment.payment_status === 2 ? "Partial" 
                     : "Pending"}
                  </span>
                </td>

              <td className="px-4 py-3 capitalize">
  {typeof payment?.others === "object"
    ? JSON.stringify(payment.others)
    : payment?.others || " "}
</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>

</div>

        {/* ========== ORDER STATUS ACTION ========== */}
        <div className={styles.ProdActions}>
          <div className={styles.pAct}>Order Status</div>
          <div className={styles.statusDrop}>
            <span className={styles.prodTag}>Change Status</span>
            <div>
              <p onClick={() => setOpen(!isOpen)} className={styles.selOpt}>
                {orderStatus[currStatus]}
                <i className="bi bi-chevron-down"></i>
              </p>
              {isOpen && (
                <div className={styles.dropOptions}>
                  {Object.values(orderStatus).map((value, index) => (
                    <p
                      onClick={(e) => handleOrderStatus(e, index + 1)}
                      key={index}
                    >
                      {value}
                    </p>
                  ))}
                </div>
              )}
            </div>
            <span className={commonCss.applyBtn} onClick={updateOrderStatus}>
              Apply
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};


// import React, { useState, useEffect } from "react";
// import styles from "../../assets/css/forms.module.css";
// import commonCss from "../../assets/css/common.module.css";

// import defaultProfile from "../../../assets/images/testimage1.png";
// import { useLocation } from "react-router-dom";
// import { useFormik } from "formik";
// import * as yup from "yup";
// import {
//   emailSchema,
//   fnameSchema,
//   gstinSchema,
//   lnameSchema,
//   mnumberSchema,
//   nationalitySchema,
//   pancardSchema,
// } from "../../../utils/validation";
// import { postData1 } from "../../../services";
// import { ToastContainer, toast } from "react-toastify";
// import prevIcon from "../../../assets/images/previous_arrow.png";
// import nextIcon from "../../../assets/images/next_arrow.png";
// import { orderStatus } from "../../MappedData";

// export const OrderForm = () => {
//   const [isDisable, setisDisable] = useState(true);
//   const [perm, updatePerm] = useState(true);
//   const location = useLocation();
//   const userData = location.state;
//   const [imgs, setImgs] = useState(userData?.product_detail?.product_images);
//   const [imgPointer, setImgPointer] = useState(0);
//   const [videoPointer, setVideoPointer] = useState(0);
//   const [videos, setVideos] = useState(userData?.product_detail?.product_video);
//   const [currStatus, setStatus] = useState(userData?.order_status);
//   const [isOpen, setOpen] = useState(false);
//   const [userMobile, setUserMobile] = useState({});

//   // console.log("user", userData.buyer_email)
//   const getUserDetail = async () => {
//     // const uid = userData.uid
//     const uid = userData.buyer
//     const formData = new FormData();
//     formData.append("uid", uid);


//     const response = await fetch(`${process.env.REACT_APP_BASEURL}/users/get_user_detail/`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "multipart/form-data",
//         authorization: `Token ${localStorage.getItem('adminAuth')}`,
//       },
//       body: formData,
//     });
//     const data = await response.json();
//     //     console.log("res",data.data
//     // )
//     setUserMobile(data.data.mobile)
//     return data;
//   };

//   // useEffect(() => {
//   //   getUserDetail()
//   // }, []);
//   const deliveryAddress = userData?.delivery_address;
//   const fullAddressText = deliveryAddress
//     ? `
//       Name: ${deliveryAddress.name}
//       Mobile: ${deliveryAddress.mobile}
//       Address: ${deliveryAddress.address}
//       Location: ${deliveryAddress.location}
//       Landmark: ${deliveryAddress.landmark}
//       City: ${deliveryAddress.city}
//       State: ${deliveryAddress.state}
//       Pincode: ${deliveryAddress.zip_code}

//       `
//     : "";

//   const formik = useFormik({
//     enableReinitialize: true,  // <--- IMPORTANT for async data

//     initialValues: {
//       orderid: userData?.id || "",
//       prodId: userData?.product_detail?.id || "",
//       delivryAdd: fullAddressText,   //  <--- show all address details
//       postType: userData?.product_detail?.post_type || "",
//       equipName: userData?.product_detail?.equip_name || "",
//       buyerFname: userData?.buyer_firstname || "",
//       buyerLname: userData?.buyer_lastname || "",
//       buyer_phone: userData?.buyer_phone || "",
//       sellerFname: userData?.seller_firstname || "",
//       sellerLname: userData?.seller_lastname || "",
//       discount: userData?.discount || "",
//       remain: userData?.remain_amount || "",
//       subTotal: userData?.sub_total || "",
//       tax: userData?.tax || "",
//       total: userData?.total || "",
//       orderStatus: userData?.order_status || "",
//       payStatus: userData?.payment_status || "",
//       payType: userData?.payment_type || "",
//     },
//   });

//   // const formik = useFormik({
//   //   initialValues: {
//   //     orderid: userData?.id,
//   //     prodId: userData?.product_detail?.id,
//   //     delivryAdd: userData?.delivery_address?.address,
//   //     postType: userData?.product_detail?.post_type,
//   //     equipName: userData?.product_detail?.equip_name,
//   //     buyerFname: userData?.buyer_firstname,
//   //     buyerLname: userData?.buyer_lastname,
//   //     sellerFname: userData?.seller_firstname,
//   //     sellerLname: userData?.seller_lastname,
//   //     discount: userData?.discount,
//   //     remain: userData?.remain_amount,
//   //     subTotal: userData?.sub_total,
//   //     tax: userData?.tax,
//   //     total: userData?.total,
//   //     orderStatus: userData?.order_status,
//   //     payStatus: userData?.payment_status,
//   //     payType: userData?.payment_type,
//   //   },

//   //   // onSubmit: function (values) {
//   //   //     handleSubmit(values);
//   //   // },
//   // });

//   const handleOrderStatus = (e, data) => {
//     let value = e.currentTarget.innerHTML;
//     setStatus(data);
//     setOpen(false);
//   };

//   const moveImg = (e, isVideo) => {
//     let name = e.currentTarget.name;
//     if (name === "prev") {
//       isVideo
//         ? setVideoPointer(videoPointer === 0 ? 0 : videoPointer - 1)
//         : setImgPointer(imgPointer === 0 ? 0 : imgPointer - 1);
//     } else {
//       isVideo
//         ? setVideoPointer(
//           videoPointer === videos?.length - 1
//             ? videos?.length - 1
//             : videoPointer + 1
//         )
//         : setImgPointer(
//           imgPointer === imgs?.length - 1 ? imgs?.length - 1 : imgPointer + 1
//         );
//     }
//   };

//   // const updateOrderStatus = async () => {
//   //   const res = await postData1(
//   //     "admin/update_order_status/",
//   //     { uid: userData?.uid, order_status: currStatus },
//   //     true,
//   //     true
//   //   );
//   //   if (res?.status_code === 200) {
//   //     toast.success("Status update successfully !");
//   //   } else {
//   //     toast.error("Something went wrong, try again !");
//   //   }
//   // };

 
//   const updateOrderStatus = async () => {
//     const deliveryAddress = userData?.delivery_address;
//     const address = deliveryAddress.address +" " + deliveryAddress.location + " " + deliveryAddress.city +" " + deliveryAddress.zip_code +" " + deliveryAddress.state
//     const res = await postData1(
//       "admin/update_order_status/",
//       {
//         uid: userData?.uid, order_status: currStatus,
//         product_name: userData?.product_detail?.equip_name,
//         buyer_name: userData?.buyer_firstname ,
//         buyer_email: userData?.buyer_email,
//         amount: userData?.total || "",
//         address:address
//       },
//       true,
//       true
//     );
//     if (res?.status_code === 200) {
//       toast.success("Status update successfully !");
//     } else {
//       toast.error("Something went wrong, try again !");
//     }
//   };

//   return (
//     <section className={styles.formCont}>
//       <ToastContainer />
//       {/* <h2>Detail Info <i onClick={()=>setisDisable(!isDisable)} style={{cursor:"pointer"}} className="bi bi-pencil-square"></i> </h2> */}
//       <form
//         className={styles.updateForm}
//         disabled={true}
//         onSubmit={formik.handleSubmit}
//       >
//         <div className={styles.formFieds}>
//           <div>
//             <p>Order Id</p>
//             <input
//               disabled={true}
//               type="text"
//               name="orderid"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.orderid}
//             />
//           </div>
//           <div>
//             <p>Product Id</p>
//             <input
//               disabled={true}
//               type="text"
//               name="prodId"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.prodId}
//             />
//           </div>
//           <div>
//             <p>Product</p>
//             <input
//               disabled={true}
//               type="text"
//               name="equipName"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.equipName}
//             />
//           </div>
//           <div>
//             <p>Product Type</p>
//             <input
//               disabled={true}
//               type="text"
//               name="postType"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={
//                 formik.values.postType === 1
//                   ? "PREOWNED"
//                   : formik.values.postType === 2
//                     ? "NEW"
//                     : formik.values.postType === 3
//                       ? "SPARE & ACCESSORIES"
//                       : "SERVICES"
//               }
//             />
//           </div>
//           <div>
//             <p>Buyer First Name</p>
//             <input
//               disabled={true}
//               type="text"
//               name="buyerFname"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.buyerFname}
//             />
//           </div>
//           <div>
//             <p>Buyer Last Name</p>
//             <input
//               disabled={true}
//               type="text"
//               name="buyerLname"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.buyerLname}
//             />
//           </div>
//           <div>
//             <p>Buyer Mobile No.</p>
//             <input
//               disabled={true}
//               type="text"
//               name="buyer_mobile"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               // value={userMobile}
//               value={formik.values.buyer_phone}
//             />
//           </div>
//           <div>
//             <p>Seller First Name</p>
//             <input
//               disabled={true}
//               type="text"
//               name="sellerFname"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.sellerFname}
//             />
//           </div>
//           <div>
//             <p>Seller Last Name</p>
//             <input
//               disabled={true}
//               type="text"
//               name="sellerLname"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.sellerLname}
//             />
//           </div>
//           <div>
//             <p>Sub Total</p>
//             <input
//               disabled={true}
//               type="text"
//               name="subTotal"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.subTotal}
//             />
//           </div>
//           <div>
//             <p>Discount</p>
//             <input
//               disabled={true}
//               type="text"
//               name="discount"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.discount}
//             />
//           </div>
//           <div>
//             <p>Tax</p>
//             <input
//               disabled={true}
//               type="text"
//               name="tax"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.tax}
//             />
//           </div>

//           <div>
//             <p>Total</p>
//             <input
//               disabled={true}
//               type="text"
//               name="total"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.total}
//             />
//           </div>
//           <div>
//             <p>Remains</p>
//             <input
//               disabled={true}
//               type="text"
//               name="remain"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.remain}
//             />
//           </div>
//           <div>
//             <p>Order Status</p>
//             <input
//               disabled={isDisable}
//               type="text"
//               name="orderStatus"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={orderStatus[formik.values.orderStatus]}
//             />
//           </div>
//           <div>
//             <p>Payment Status</p>
//             <input
//               disabled={isDisable}
//               type="text"
//               name="payStatus"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={
//                 formik.values.payStatus === 1
//                   ? "Pending"
//                   : formik.values.payStatus === 2
//                     ? "Partial"
//                     : "Completed"
//               }
//             />
//           </div>

//           <div>
//             <p>Payment Type</p>
//             <input
//               disabled={isDisable}
//               type="text"
//               name="payType"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.payType === 1 ? "Active" : "InActive"}
//             />
//           </div>

//           <div>
//             <p>Delivery Address</p>
//             <textarea
//               disabled={isDisable}
//               name="delivryAdd"
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               value={formik.values.delivryAdd}
//               rows={10}
//               className="w-full border rounded p-2"
//             ></textarea>

//           </div>

//           {/* images && videos */}
//           <div>
//             <p>Imges</p>
//             <div
//               style={{
//                 backgroundImage: `url(${imgs[imgPointer]?.product_images})`,
//               }}
//               className={styles.imgeCont}
//             ></div>
//             <div className={styles.vidMover}>
//               <img
//                 src={prevIcon}
//                 onClick={(e) => moveImg(e, 0)}
//                 alt="Prev"
//                 name="prev"
//               />
//               <p style={{ textAlign: "center" }}>
//                 {imgs?.length === 0 ? 0 : imgPointer + 1}/{imgs?.length}
//               </p>
//               <img
//                 src={nextIcon}
//                 onClick={(e) => moveImg(e, 0)}
//                 alt="Next"
//                 name="next"
//               />
//             </div>
//           </div>

//           <div>
//             <p>videos</p>
//             <video className={styles.imgeCont} controls>
//               <source src={videos[videoPointer]} type="video/mp4" />
//             </video>
//             <div className={styles.vidMover}>
//               <img
//                 src={prevIcon}
//                 onClick={(e) => moveImg(e, 1)}
//                 alt="Prev"
//                 name="prev"
//               />
//               <p style={{ textAlign: "center" }}>
//                 {videos?.length === 0 ? 0 : videoPointer + 1}/{videos?.length}
//               </p>
//               <img
//                 src={nextIcon}
//                 onClick={(e) => moveImg(e, 1)}
//                 alt="Next"
//                 name="next"
//               />
//             </div>
//           </div>
//         </div>
//       </form>
//       <div className={styles.ProdActions}>
//         <div className={styles.pAct}>Actions</div>

//         <div className={styles.statusDrop}>
//           <span className={styles.prodTag}>Order Status</span>
//           <div>
//             <p onClick={() => setOpen(!isOpen)} className={styles.selOpt}>
//               {orderStatus[currStatus]}
//               <i className="bi bi-chevron-down"></i>
//             </p>
//             {isOpen && (
//               <div className={styles.dropOptions}>
//                 {Object.values(orderStatus).map((value, index) => {
//                   return (
//                     <p
//                       onClick={(e) => handleOrderStatus(e, index + 1)}
//                       key={index}
//                     >
//                       {value}
//                     </p>
//                   );
//                 })}
//               </div>
//             )}
//           </div>
//           <span className={commonCss.applyBtn} onClick={updateOrderStatus}>
//             Apply
//           </span>
//         </div>
//       </div>
//     </section>
//   );
// };
